<script setup lang="ts">
const props = defineProps<{ backgroundUrl: string }>();
</script>

<template>
  <div class="solutions-callout-block" :style="{ backgroundImage: `url(${props.backgroundUrl})` }">
    <div class="solutions-callout-logo"><slot name="logo" /></div>
    <div class="container">
      <div class="callout-details">
        <div class="details-left">
          <slot name="details-left" />
        </div>
      </div>

      <div class="details-right">
        <slot name="details-right" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.solutions-callout-block {
  background-position: center;
  background-size: cover;
  border-bottom: 1px white dotted;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1366px;
  padding: 8rem 0;
  width: 100%;

  .solutions-callout-logo {
    padding-left: 8rem;
  }

  .container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 3rem;
    justify-content: center;
    padding: 0 8rem;
    position: relative;
    width: 100%;

    @media only screen and (max-device-width: 600px) {
      flex-direction: column;
      padding: 0 2rem;
    }

    > * {
      flex: 40%;
    }

    .callout-details {
      display: flex;
      flex: 60%;
      flex-direction: column;
      gap: 5rem;
      padding-left: 3.5rem;
      position: relative;
      width: 100%;

      @media only screen and (max-device-width: 600px) {
        //padding-left: 0;
        flex: 100%;
      }

      > div {
        border-left: 1px dotted white;
        padding-left: 1.5rem;
      }

      .details-left {
        display: flex;
        flex-direction: column;
        gap: 2rem;
      }

      &:before {
        background-color: #6734bb;
        content: "";
        height: 20px;
        left: 0;
        position: absolute;
        top: 0;
        width: 20px;
      }

      h2 {
        color: white;
        font-size: 4rem;
        font-weight: 200;
        line-height: 1;
        margin: 0;
        padding: 0;

        b {
          text-transform: uppercase;
        }

        sup {
          font-size: 12px;
          font-weight: 200;
          line-height: 0;
          position: relative;
          top: -0.4rem;
        }
      }

      h3 {
        font-size: 3rem;
        margin: 1rem 0 0.4rem;
      }

      p {
        color: white;
        font-size: 2.5rem;
        font-weight: 200;
        margin: 0;
        padding: 0;
      }

      a {
        color: white;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
          // padding-left: 3rem;
          font-size: 2.4rem;
          font-weight: 200;
          line-height: 1;
          max-width: 90%;
          position: relative;
          // &:before {
          //   content: "";
          //   background: url(/assets/dots.png) no-repeat;
          //   width: 10px;
          //   height: 10px;
          //   position: absolute;
          //   top: 0.5rem;
          //   left: 0;
          // }
        }
      }
    }
  }
}
</style>
